import React from 'react';
import { useTranslation } from 'react-i18next';

import CDIcon from '../../assets/icons/icon_cd.svg';

import { ImageListTableButton } from './ImageListTableButtons';

interface RequestCdButtonProps {
  onClick?: () => void;
}
export const RequestCdButton = ({ onClick }: RequestCdButtonProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.cdButton',
  });
  return (
    <ImageListTableButton icon={CDIcon} text={t('label')} onClick={onClick} />
  );
};
